import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import Header from "../../Common/Header/HeaderNavigation";
import CategoryListHeader from "./CategoryListHeader";
import VendorCategorySection from "./VendorCategorySection";
import Footer from "../../Common/Footer/VendorFooterPremium";
import {
  getSoftwareCategoryList,
  getSoftwareCategoryListByParam,
  getServicesCategoryListByParam,
} from "../../Common/CommonMethods";
import parallel from "async/parallel";
import PageMeta from "../../Common/PageMeta";
import * as actionTypes from "../../../store/actions/actionTypes";
import Loader from "../../Common/Loader/";
import Canonical from "../../Common/Canonical";
import { openAPI } from "../../../config";
import LandingPageByLocation from "./ByLocation";

class VendorCategoryList extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      isDataLoaded: false,
      selectedValue: "",
      activeTab: "all-vendor",
      pathname: "",
      search: "",
      key: "",
      currentView: 15,
      serverError: "Error while fetching data from server",
    };
    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.updateActiveTab = this.updateActiveTab.bind(this);
    this.setCurrentView = this.setCurrentView.bind(this);
    this.refineURLForQuery = this.refineURLForQuery.bind(this);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.props.resetCategoryList();
  }

  componentDidCatch(error, errorInfo) {
    // console.log('componentDidCatch :: error ', error);
    // console.log('componentDidCatch :: errorInfo ', errorInfo);
  }

  UNSAFE_componentWillMount() {
    this._isMounted = true;
    this.props.resetCategoryList();
    const regex = new RegExp("/all$");
    this.setState({
      pathname: this.props.location.pathname,
      search: this.props.location.search,
      key: this.props.location.key,
      currentView: regex.test(this.props.location.pathname) ? "all" : 15,
    });
    parallel(
      [
        (cb) => {
          let requestURL = this.refineURLForQuery(this.props.location);
          openAPI
            .get(`${process.env.REACT_APP_API_URL}${requestURL}`, {
              withCredentials: true,
            })
            .then((response) => {
              if (response.data.status === 200) {
                this.props.setCategoryList(response.data);
                cb(null);
              } else {
                cb(this.state.serverError);
              }
            })
            .catch((err) => {
              if (err.response.status === 404) {
                this.props.history.push(
                  `${this.props.location.pathname}/pagenotfound`
                );
              }
            });
        },
      ],
      (err, results) => {
        if (!err && this._isMounted) {
          this.setState({ isDataLoaded: true });
        } else {
          alert(err);
        }
      }
    );
  }

  componentDidUpdate() {
    if (this._isMounted && this.props.location.key !== this.state.key) {
      this.props.setDataLoadedFalseList();
      this.props.resetCategoryList();
      this.setState({
        pathname: this.props.location.pathname,
        search: this.props.location.search,
        key: this.props.location.key,
        isDataLoaded: false,
      });
      let apiCriteriaToFetch = `${
        process.env.REACT_APP_API_URL
      }${this.props.location.pathname.replace(/\/all$/, "")}`;
      if (!!this.props.location.search) {
        apiCriteriaToFetch = `${apiCriteriaToFetch}${this.props.location.search}&view=${this.state.currentView}`;
      } else {
        apiCriteriaToFetch = `${apiCriteriaToFetch}?view=${this.state.currentView}`;
      }
      openAPI
        .get(`${apiCriteriaToFetch}`, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.data.status === 200 && this._isMounted) {
            this.setState({ isDataLoaded: true });
            this.props.setCategoryList(response.data);
          } else {
            alert(this.state.serverError);
          }
        });
    }
  }

  setCurrentView = (view) => {
    if (this._isMounted) {
      this.setState(
        (prevState) => {
          return { currentView: view };
        },
        () => {
          this.props.history.push(`${this.props.location.pathname}`);
        }
      );
    }
  };

  updateActiveTab = (activeTab) => {
    if (this._isMounted) {
      this.setState({ activeTab: activeTab });
    }
  };

  onChangeHandler = (event) => {
    event.persist();
    const index = event.target.selectedIndex;
    const optionElement = event.target.childNodes[index];
    const option = optionElement.getAttribute("rel");

    axios
      .all([
        getSoftwareCategoryListByParam,
        getServicesCategoryListByParam(this.props.match.params.domain, option),
      ])
      .then(
        axios.spread((response) => {
          if (this._isMounted) {
            this.setState({
              selectedValue: option,
              isDataLoaded: true,
              ...response.data,
            });
          }
        })
      );
  };

  resetFilter = () => {
    if (this._isMounted) {
      this.setState({ selectedValue: "" });
    }
    axios.all([getSoftwareCategoryList(this.props.match.params.domain)]).then(
      axios.spread((response) => {
        if (this._isMounted) {
          this.setState({ isDataLoaded: true, ...response.data });
        }
      })
    );
  };

  refineURLForQuery = (location) => {
    const regex = new RegExp("/all$");
    if (regex.test(location.pathname)) {
      const refinedURL = location.pathname.replace(regex, "");
      let qString = queryString.parse(location.search);
      //console.log('qString :: ', Object.keys(qString).length);
      if (Object.keys(qString).length > 0) {
        if (qString.view) {
          const searchParam = location.search.replace(/view=\w+/, "view=all");
          return `${refinedURL}${searchParam}`;
        } else {
          return `${refinedURL}${location.search}&view=all`;
        }
      } else {
        return `${refinedURL}?view=all`;
      }
    } else {
      return `${location.pathname}${location.search}`;
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.state.isDataLoaded ? (
          <Helmet>
            <script type="text/javascript">window.prerenderReady = true</script>
          </Helmet>
        ) : (
          <Helmet>
            <script type="text/javascript">
              window.prerenderReady = false
            </script>
          </Helmet>
        )}
        {this.props.vendorCategory.isDataLoaded ? (
          <React.Fragment>
            <PageMeta {...this.props.vendorCategory} />
            {!queryString.parse(this.props.location.search).sort && (
              <Canonical />
            )}

            <Header />
            {!!this.props.vendorCategory &&
              !!this.props.vendorCategory.usa_cities && (
                <LandingPageByLocation {...this.props.vendorCategory} />
              )}
            {!!this.props.vendorCategory &&
              !!this.props.vendorCategory.results && (
                <React.Fragment>
                  <CategoryListHeader {...this.props.vendorCategory} />
                  <VendorCategorySection
                    //onChangeHandler={this.onChangeHandler}
                    resetFilter={this.resetFilter}
                    //updateActiveTab={this.updateActiveTab}
                    setCurrentView={this.setCurrentView}
                    {...this.state}
                    {...this.props.vendorCategory}
                  />
                </React.Fragment>
              )}

            <Footer />
          </React.Fragment>
        ) : (
          <Loader />
        )}
      </React.Fragment>
    );
  }
}

const VendorCategoryListWithRouter = withRouter(VendorCategoryList);
const mapStateToProps = (state) => {
  return {
    vendorCategory: state.vendorCategory,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCategoryList: (data) =>
      dispatch({
        type: actionTypes.SET_CATEGORY_LIST,
        payload: data,
      }),
    setCategoryOptions: (data) =>
      dispatch({
        type: actionTypes.SET_CATEGORY_DD_OPT,
        payload: data,
      }),
    setDataLoadedFalseList: () =>
      dispatch({
        type: actionTypes.SET_CATEGORY_DATALOADER_FALSE,
      }),
    resetCategoryList: () =>
      dispatch({
        type: actionTypes.RESET_CATEGORY_LIST,
      }),
    resetCatergoryResult: () =>
      dispatch({
        type: actionTypes.UPDTAE_CATEGORY_RESULT,
        payload: [],
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorCategoryListWithRouter);
